import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { Logo } from "@/components/SiteHeader";
import { T } from "@/i18n";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="no-print bg-gray-900 py-14 text-white/60">
    <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 md:flex-row md:items-center md:justify-between md:px-10">
      <Logo light />
      <div className="flex flex-col gap-2 text-sm md:items-end">
        <p><T>Ogni viaggio può fare la differenza. · tripsaver.it</T></p>
        <div className="flex items-center gap-4">
          <a data-testid="footer-instagram-link" href="https://www.instagram.com/tripsaver.it/" target="_blank" rel="noopener noreferrer"
            aria-label="Instagram @tripsaver.it"
            className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3.5 py-2 text-white/90 transition-colors hover:bg-emerald-600 hover:text-white">
            <Instagram className="h-4 w-4" /><span>@tripsaver.it</span>
          </a>
          <Link data-testid="footer-privacy-link" to="/privacy" className="text-white/80 underline-offset-4 hover:text-white hover:underline"><T>Privacy policy</T></Link>
        </div>
      </div>
    </div>
  </footer>
);
